import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

const footerLinks = {
  categories: categories.slice(0, 5).map((c) => ({ label: c.name, path: `/category/${c.slug}` })),
  support: [
    { label: '关于我们', path: '/about' },
    { label: '联系我们', path: '/about#contact' },
    { label: '常见问题', path: '/about#faq' },
    { label: '用户协议', path: '/about' },
    { label: '隐私政策', path: '/about' },
  ],
  discovery: [
    { label: '热门排行', path: '/' },
    { label: '最新更新', path: '/' },
    { label: '编辑推荐', path: '/' },
    { label: '完结漫画', path: '/category/action' },
    { label: '新作上架', path: '/' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10">
            <div className="lg:col-span-2">
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-book-open-line text-lg text-background-50"></i>
                </div>
                <span className="font-heading text-xl font-bold tracking-tight text-background-50">
                  韩漫网
                </span>
              </Link>
              <p className="text-sm text-background-400 leading-relaxed max-w-sm">
                韩漫网作为免费资源宝库，提供完整漫画大全与韩漫完整在线观看服务。我们致力于为广大韩漫爱好者打造最优质的阅读平台，让每一部精彩作品触手可及。
              </p>
              <div className="flex items-center gap-3 mt-5">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-600 text-background-300 hover:text-background-50 transition-all duration-200 cursor-pointer" rel="nofollow">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-600 text-background-300 hover:text-background-50 transition-all duration-200 cursor-pointer" rel="nofollow">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-600 text-background-300 hover:text-background-50 transition-all duration-200 cursor-pointer" rel="nofollow">
                  <i className="ri-bilibili-line text-lg"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 uppercase tracking-wider mb-4">漫画分类</h4>
              <ul className="space-y-2.5">
                {footerLinks.categories.map((link) => (
                  <li key={link.label}>
                    <Link to={link.path} className="text-sm text-background-400 hover:text-background-50 transition-colors duration-200">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 uppercase tracking-wider mb-4">帮助支持</h4>
              <ul className="space-y-2.5">
                {footerLinks.support.map((link) => (
                  <li key={link.label}>
                    <Link to={link.path} className="text-sm text-background-400 hover:text-background-50 transition-colors duration-200">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 uppercase tracking-wider mb-4">发现探索</h4>
              <ul className="space-y-2.5">
                {footerLinks.discovery.map((link) => (
                  <li key={link.label}>
                    <Link to={link.path} className="text-sm text-background-400 hover:text-background-50 transition-colors duration-200">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background-500">
              &copy; 2026 韩漫网 kcptesw.com. 保留所有权利.
            </p>
            <div className="flex items-center gap-4 text-sm text-background-500">
              <Link to="/about" className="hover:text-background-300 transition-colors">用户协议</Link>
              <span className="text-background-700">|</span>
              <Link to="/about" className="hover:text-background-300 transition-colors">隐私政策</Link>
              <span className="text-background-700">|</span>
              <Link to="/about" className="hover:text-background-300 transition-colors">版权声明</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}